import { connect } from '../../../../react-redux';
import makeEditable from '../../../../../common/components/shared/functionality/makeEditable';
import DragHandle from './presenter';
import { screenreaderNotification } from '../../../../../common/actions/alerts';
import { moveTemporaryQuizEntry } from '../../../../../common/actions/modifications';
import { moveQuizEntry } from '../../../../../building/api/quizEntries';
import { set as setUI, clear as clearUI } from '../../../../../common/actions/ui';
import { openMoveImmutableModal } from '../../../../../common/actions/modal';
import { MOVED_QUIZ_ENTRY, MOVED_IN_SIDEBAR } from '@instructure/quiz-common';
import { getActiveQuiz } from '../../../../selectors/quizzes';
export var mapStateToProps = function mapStateToProps(state, props) {
  var activeQuiz = getActiveQuiz(state);
  return {
    movedInSidebar: state.getIn(['ui', MOVED_IN_SIDEBAR]),
    movedQuizEntry: state.getIn(['ui', MOVED_QUIZ_ENTRY]),
    quizId: activeQuiz.id
  };
};
var mapDispatchToProps = {
  clearUI: clearUI,
  moveQuizEntry: moveQuizEntry,
  moveTemporaryQuizEntry: moveTemporaryQuizEntry,
  openMoveImmutableModal: openMoveImmutableModal,
  screenreaderNotification: screenreaderNotification,
  setUI: setUI
};
export default makeEditable(connect(mapStateToProps, mapDispatchToProps)(DragHandle));